import React, { useState } from 'react';
import axios from 'axios';
import styles from '../styles/AdicionarMarcaProduto.module.css';
//esse é o certo
const AdicionarMarcaProduto = () => {
  const [marca, setMarca] = useState({ nome: '', imagem: '' });
  const [produto, setProduto] = useState({
    nome: '',
    preco: '',
    polos: '',
    tensao: '',
    estoque: '',
    marca: '',
  });
  const [marcasExistentes, setMarcasExistentes] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [mostrarFormularioProduto, setMostrarFormularioProduto] = useState(true); 

  const apiUrl = 'https://crmesquita.com.br';  

  React.useEffect(() => {
    axios
      .get(`${apiUrl}/api/marcas/`)
      .then((response) => setMarcasExistentes(response.data))
      .catch((error) => console.error('Erro ao buscar marcas:', error));
  }, []);

  const handleMarcaChange = (e) => {
    const { name, value } = e.target;
    setMarca({ ...marca, [name]: value });
  };

  const handleProdutoChange = (e) => {
    const { name, value } = e.target;
    setProduto({ ...produto, [name]: value });
  };

  const handleAdicionarMarca = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/api/marcas/`, marca);
      setSuccessMessage('Marca adicionada com sucesso!');
      setErrorMessage('');
      setMarca({ nome: '', imagem: '' });
    } catch (error) {
      setErrorMessage('Erro ao adicionar marca. Tente novamente.');
      setSuccessMessage('');
    }
  };

  const handleAdicionarProduto = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${apiUrl}/api/produtos/`, produto);
      setSuccessMessage('Produto adicionado com sucesso!');
      setErrorMessage('');
      setProduto({
        nome: '',
        preco: '',
        polos: '',
        tensao: '',
        estoque: '',
        marca: '',
      });
    } catch (error) {
      setErrorMessage('Erro ao adicionar produto. Tente novamente.');
      setSuccessMessage('');
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Adicionar Marca e Produto</h1>

    
      {mostrarFormularioProduto ? (
        <form onSubmit={handleAdicionarProduto} className={styles.form}>
          <h2 className={styles.formTitle}>Adicionar Produto</h2>
          <div className={styles.formGroup}>
            <label htmlFor="nome" className={styles.label}>Nome do Produto:</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={produto.nome}
              onChange={handleProdutoChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="preco" className={styles.label}>Preço:</label>
            <input
              type="number"
              id="preco"
              name="preco"
              value={produto.preco}
              onChange={handleProdutoChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="polos" className={styles.label}>Polos:</label>
            <input
              type="text"
              id="polos"
              name="polos"
              value={produto.polos}
              onChange={handleProdutoChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="tensao" className={styles.label}>Tensão:</label>
            <input
              type="text"
              id="tensao"
              name="tensao"
              value={produto.tensao}
              onChange={handleProdutoChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="estoque" className={styles.label}>Estoque:</label>
            <input
              type="number"
              id="estoque"
              name="estoque"
              value={produto.estoque}
              onChange={handleProdutoChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="marca" className={styles.label}>Marca:</label>
            <select
              id="marca"
              name="marca"
              value={produto.marca}
              onChange={handleProdutoChange}
              className={styles.select}
              required
            >
              <option value="">Selecione uma marca</option>
              {marcasExistentes.map((marca) => (
                <option key={marca.id} value={marca.nome}>
                  {marca.nome}
                </option>
              ))}
            </select>
          </div>
          <button type="submit" className={styles.button}>Adicionar Produto</button>
        </form>
      ) : (
        <form onSubmit={handleAdicionarMarca} className={styles.form}>
          <h2 className={styles.formTitle}>Adicionar Marca</h2>
          <div className={styles.formGroup}>
            <label htmlFor="nome" className={styles.label}>Nome da Marca:</label>
            <input
              type="text"
              id="nome"
              name="nome"
              value={marca.nome}
              onChange={handleMarcaChange}
              className={styles.input}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="imagem" className={styles.label}>URL da Imagem:</label>
            <input
              type="text"
              id="imagem"
              name="imagem"
              value={marca.imagem}
              onChange={handleMarcaChange}
              className={styles.input}
              required
            />
          </div>
          <button type="submit" className={styles.button}>Adicionar Marca</button>
        </form>
      )}

  
      <button
        onClick={() => setMostrarFormularioProduto(!mostrarFormularioProduto)}
        className={styles.button}
      >
        {mostrarFormularioProduto ? 'Adicionar Marca' : 'Adicionar Produto'}
      </button>


      {successMessage && <p className={styles.successMessage}>{successMessage}</p>}
      {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
    </div>
  );
};

export default AdicionarMarcaProduto;
